const Bullets = ({
  setActive,
  active,
  borderColor,
  tooltipTitle,
  bulletColor,
  id,
  containerStyle,
  procAdded,
  setProcAdded,
}) => {
  return (
    <div
      className="p2"
      style={{
        border: active == id ? `1px solid ${borderColor}` : "unset",
        ...containerStyle,
      }}
    >
      <div
        data-toggle="tooltip"
        data-placement="top"
        title={tooltipTitle}
        style={{
          width: 12,
          height: 12,
          borderRadius: "50%",
          backgroundColor: bulletColor,
          margin: 3,
        }}
        onClick={() => {
          setActive(id);
          // setProcAdded(!procAdded);
        }}
      ></div>
    </div>
  );
};

export default Bullets;
